import { useSearchParams } from "react-router-dom";

export const usePageNumber = (defaultPage = 1) => {
    const [searchParams, setSearchParams] = useSearchParams();
    // const currentPage = parseInt(searchParams.get('page') || defaultPage, 10);

    const setPage = (newPage) => {
        searchParams.set('page', newPage);
        setSearchParams(searchParams);
    };

    return [setPage];
}

